import { InstanceResolverInterface } from '@/util/instanceResolver'

export interface GetAction {
  readonly location: Pick<Location, 'search'>
  readonly instanceResolver: Pick<InstanceResolverInterface, 'isSingle'>
  readonly brandEnglishName: string | null
}

/**
 * 商品一覧絞り込み画面からsubmitすべき対象のactionを決定する
 *
 * クエリパラメータ from の有無とインスタンスの種類によって返すactionが決定される.
 */
export function getAction(param: GetAction): string {
  const from = new URLSearchParams(param.location.search).get('from')
  if (from) {
    return decodeURIComponent(from)
  }
  if (param.instanceResolver.isSingle()) {
    return '/itemlist'
  }

  return `/${param.brandEnglishName}/itemlist`
}
